import axios from 'axios'
import config from '../config.js'
// import { useAuthStore } from '@/stores/auth'

const service = axios.create({
    baseURL: `${config.API_BASE_URL}/api`,
    timeout: config.timeout
})

// 请求拦截器
service.interceptors.request.use(config => {
    const token = localStorage.getItem('token')
    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }
    return config
})

// 响应拦截器
service.interceptors.response.use(
    response => response.data,
    error => {
    //     if (error.response.status === 401) {
    //         // 触发登录弹窗
    //         // store.commit('auth/showLoginModal', true)
    //           const authStore = useAuthStore()
    //   authStore.showLoginModal(true)
    //     }
        return Promise.reject(error)
    }
)

export default service
